import templateUrl from 'emun.salesrep/salesrep-projected-bookings.htm';
import salesrepConfig from 'emun.salesrep/salesrep.config';
import basicController from 'servicestack/basic.controller.properties';
import ServiceBus from 'servicestack/service-bus';

class SalesRepProjectedBookingsController {
  constructor($window, $rootScope, retailerPrompt, createAutoQuery) {
    let $ctrl = this;
    basicController($ctrl);
    $ctrl.bus = new ServiceBus();
    var context = $ctrl.context || 'rep';
    var timezone = moment.tz.guess();
    this.currentDate = moment.tz(timezone).format("DD/MM/YYYY");

    this.nextWeekActivities = {
      total: 0,
      count: 0
    };
    this.thisMonthActivities = {
      total: 0,
      count: 0,
      goal: 0
    };
    this.nextMonthActivities = {
      total: 0,
      count: 0,
      goal: 0
    };

    var dashboardActivityType = salesrepConfig.dashboardActivityType || "Store Appointment";
    dashboardActivityType = dashboardActivityType.replace(" ", "%20");
    var repGroupBy = '';
    var repFilter = "";
    var activityFilter = "";

    if (context === 'writingRep') {
      repGroupBy = '&GroupBy=WritingRep';
      repFilter = '&WritingRep=' + $ctrl.wrid;
      activityFilter = '&InsideSales=true&Username=' + $ctrl.wrid;

      if ($ctrl.salesRepId) {
        activityFilter = '&InsideSales=true';
      }
    } else if (context === 'manager') {
      if ($ctrl.insideSales === 'true') {
        repGroupBy = '&GroupBy=WritingRep';
        repFilter = '&ManagerID=' + $ctrl.rep.id;
      }
      else {
        repGroupBy = '&GroupBy=SalesRep';
        repFilter = '&ManagerID=' + $ctrl.rep.id;
      }
    }
    else { //executive
      if ($ctrl.insideSales === 'true') {
        repGroupBy = '&GroupBy=WritingRep';
        activityFilter = '&InsideSales=true';
      } else if (context == "executive") {
        repGroupBy = '&GroupBy=SalesRep';
      }
      else {
        repGroupBy = '&GroupBy=SalesRep';
        repFilter = '&SalesRep=' + $ctrl.rep.id;
      }
    }

    if ($ctrl.insideSales === 'true') {
      dashboardActivityType = "Phone/Email";
    }

     this.weeklyAverageQuery = createAutoQuery({
      url: 'QueryWeeklyBookingAverage.json?ss=1&count=weeknumber&sum=WeekAvg' + repGroupBy + repFilter,
      pageSize: 1000,
      autoLoad: true,
      onLoaded: function (avgArgs) {
        var totalavg = 0;
        avgArgs.results.forEach(function (result) {
          totalavg += result.sumWeekAvg / result.countweeknumber;
        });
        //console.info("totalavg", totalavg);
        //console.info("avgArgs.total", avgArgs.total);
        $ctrl.avgAppointment = totalavg / avgArgs.total;
      }
    });
      

    if (context === 'writingRep') {
      repFilter = '&username=' + $ctrl.wrid;
      if ($ctrl.salesRepId) {
        repFilter = '&SalesRepLookupId=' + $ctrl.salesRepId;
      }
    } else if (context === 'manager') {
      repGroupBy = '&GroupBy=WritingRep';
      repFilter = '&ManagerID=' + $ctrl.rep.id;
    }
    else { //executive
      if ($ctrl.rep) {
        repFilter = '&username=' + $ctrl.rep.id;
      }
    }
    
    this.nextWeekActivitiesCount = createAutoQuery({
      url: 'QueryActivitiesJoin.json?typeIn=' + dashboardActivityType + repFilter + '&dateRange=NextWeek&Count=Id&GroupBy=username' + activityFilter,
      autoLoad: true,
      pageSize: 1000,
      criteria: {
        currentDate: this.currentDate
      },
      onLoaded: function (args) {
        args.results.forEach(function (total) {
          $ctrl.nextWeekActivities.count += total.Total;
        });
      }
    });

    this.thisMonthActivitiesCount = createAutoQuery({
      url: 'QueryActivitiesJoin.json?typeIn=' + dashboardActivityType + repFilter + '&dateRange=Month&Count=Id&GroupBy=username' + activityFilter,
      autoLoad: true,
      pageSize: 1000,
      criteria: {
        currentDate: this.currentDate
      },
      onLoaded: args => {
        args.results.forEach(function (total) {        
          $ctrl.thisMonthActivities.count += total.Total;    
        });
      }
    });
    this.nextMonthActivitiesCount = createAutoQuery({
      url: 'QueryActivitiesJoin.json?typeIn=' + dashboardActivityType + repFilter + '&dateRange=NextMonth&Count=Id&GroupBy=username' + activityFilter,
      autoLoad: true,
      pageSize: 1000,
      criteria: {
        currentDate: this.currentDate
      },
      onLoaded: args => {
        args.results.forEach(function (total) {
          $ctrl.nextMonthActivities.count += total.Total;
        });
      }
    });

    //re-setup the group by and filters
    if (context === 'writingRep') {
      repGroupBy = '&GroupBy=WritingRep';
      repFilter = '&WritingRep=' + $ctrl.wrid;
    } else if (context === 'manager') {
      if ($ctrl.insideSales === 'true') {
        repGroupBy = '&GroupBy=WritingRep';
        repFilter = '&ManagerID=' + $ctrl.rep.id;
      }
      else {
        repGroupBy = '&GroupBy=SalesRepID';
        repFilter = '&ManagerID=' + $ctrl.rep.id;
      }
    }
    else { //executive
      if ($ctrl.insideSales === 'true') {
        repGroupBy = '&GroupBy=WritingRep';
      }
      else {
        repGroupBy = '&GroupBy=SalesRepID';
      }
    }


    $ctrl.lastytdSalesQuery = createAutoQuery({
      url: 'QuerySalesDailyTotals.json?dateRange=MonthLY&Source=ROAD&Sum=OrderTotal&Count=OrderTotal' + repGroupBy + repFilter,
      //&GroupBy=SalesRepID & salesrepId=' + $ctrl.repId,
      autoLoad: true,
      pageSize: 1000,
      onLoaded: function (args) {
        if (args.total > 0) {
          $ctrl.thisMonthActivities.total = Math.round(args.first.sumOrderTotal);
        }
      }
    });
    $ctrl.lastytdSalesQuery = createAutoQuery({
      url: 'QuerySalesDailyTotals.json?dateRange=NextMonthLY&Source=ROAD&Sum=OrderTotal&Count=OrderTotal' + repGroupBy + repFilter,
      //& GroupBy=SalesRepID& salesrepId=' + $ctrl.repId,
      autoLoad: true,
      pageSize: 1000,
      onLoaded: function (args) {
        if (args.total > 0) {
          $ctrl.nextMonthActivities.total = Math.round(args.first.sumOrderTotal);
        }
      }
    });
  }
}

let SalesRepProjectedBookings = {
  bindings: {
    rep: '<',
    context: '@',
    insideSales: '@',
    wrid: '@',
    salesRepId: '@'
  },
  controller: SalesRepProjectedBookingsController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};


export default SalesRepProjectedBookings;